export default {
  name: 'despertar',
  formula: [
    {
      name: 'aceite esencial de naranja',
      quantity: 7.5,
      unit: 'ml',
      ref: 'naranja'
    },
    {
      name: 'aceite esencial de bergamota',
      quantity: 1.25,
      unit: 'ml',
      ref: 'bergamota'
    },
    {
      name: 'aceite esencial de mandarina',
      quantity: 4,
      unit: 'ml',
      ref: 'mandarina'
    },
    {
      name: 'aceite esencial de citronela',
      quantity: 3.75,
      unit: 'ml',
      ref: 'citronela'
    },
    {
      name: 'aceite esencial de limón',
      quantity: 5,
      unit: 'ml',
      ref: 'limon'
    },
    {
      name: 'aceite esencial de toronja',
      quantity: 7,
      unit: 'ml',
      ref: 'toronja'
    },
    {
      name: 'aceite esencial de hierbabuena',
      quantity: 7.5,
      unit: 'ml',
      ref: 'hierbabuena'
    },
  ],
}
